import React, { Fragment } from "react";
import { Image } from "react-bootstrap";
import { H4, P } from "../../../AbstractElements";
import { FinalSection, Finaltext, Finaltext1, Finaltext2 } from "../../../Constant";

const Timeline1 = () => {
  return (
    <Fragment>
      <section className="cd-container" id="cd-timeline">
        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-picture bg-primary">
            <i className="icon-pencil-alt" />
          </div>
          <div className="cd-timeline-content">
            <H4 className="vertical-timeline-element-subtitle">Start With This 1</H4>
            <P>{Finaltext}</P>
            <span className="cd-date">
              Jan <span className="counter"> 14</span>
            </span>
          </div>
        </div>
        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-movie bg-secondary">
            <i className="icon-video-camera" />
          </div>
          <div className="cd-timeline-content">
            <H4 className="vertical-timeline-element-subtitle">Video Tutorial 2</H4>
            <div className="embed-responsive embed-responsive-21by9 m-t-20">
              <iframe src="https://www.youtube.com/embed/wpmHZspl4EM" allowFullScreen title="myFrame"></iframe>
            </div>
            <span className="cd-date">
              Jan <span className="counter">18</span>
            </span>
          </div>
        </div>

        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-picture bg-success bounce-in">
            <i className="icon-image" />
          </div>
          <div className="cd-timeline-content bounce-in">
            <H4 className="vertical-timeline-element-subtitle">Layout Drafts 3</H4>
            <Image className="img-fluid p-t-20" src={require("../../../assets/images/banner/1.jpg")} alt="timelineImg1" />
            <span className="cd-date">
              Jan <span className="counter">24</span>
            </span>
          </div>
        </div>

        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-location bg-info bounce-in">
            <i className="icon-pulse" />
          </div>
          <div className="cd-timeline-content bounce-in">
            <H4 className="vertical-timeline-element-subtitle">Audio Tutorial 4</H4>
            <audio controls preload="none">
              <source src={require("../../../assets/audio/horse.ogg")} type="audio/ogg" />
              {Finaltext1}
            </audio>
            <span className="cd-date">
              Feb <span className="counter">14</span>
            </span>
          </div>
        </div>

        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-location bg-warning bounce-in">
            <i className="icon-image" />
          </div>
          <div className="cd-timeline-content bounce-in">
            <H4 className="vertical-timeline-element-subtitle">Team Work 5</H4>
            <Image className="img-fluid p-t-20" src={require("../../../assets/images/banner/3.jpg")} alt="timelineImg2" />
            <span className="cd-date">
              Feb <span className="counter">18</span>
            </span>
          </div>
        </div>

        <div className="cd-timeline-block">
          <div className="cd-timeline-img cd-movie bg-danger bounce-in">
            <i className="icon-pencil-alt" />
          </div>
          <div className="cd-timeline-content bounce-in">
            <H4 className="vertical-timeline-element-subtitle">{FinalSection}</H4>
            <P>{Finaltext2}</P>
            <span className="cd-date">
              Feb <span className="counter">26</span>
            </span>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default Timeline1;
